// Coquille reelle (decision de Louka du 01/10) : le chat porte la coquille commune aux trois apps.
// Ce pont, monte une fois a la racine du routeur (RootRouterLayout), tient l'app au courant :
//  - il annonce chaque emplacement du chat (l'app en fait son adresse du haut : un rechargement
//    reprend la meme page, la bulle de messagerie suit les conversations) ;
//  - il ouvre au chargement la page de l'app demandee par l'app (/assistant?page=...) ;
//  - il ouvre dans le rectangle les pages que l'app lui demande (citations, liens).
// Sans modele `coquille`, il ne fait rien.
import {
  cheminDeLApp,
  espaceDeLaRoute,
  ouvrirDuMessage,
  routeDeLaPageDeLApp,
  routeDuChat,
} from "@app/lib/compta/coquille";
import { envoyer, useNavigationDeLApp } from "@app/lib/compta/navigation_app";
import { useAppRouter } from "@app/lib/platform";
import { useEffect, useRef } from "react";

export function PontDeLaCoquille() {
  const nav = useNavigationDeLApp();
  const router = useAppRouter();
  const coquille = nav?.coquille === true;
  const { asPath, push, replace } = router;
  const depart = useRef(false);
  const routeur = useRef({ asPath, push });

  useEffect(() => {
    routeur.current = { asPath, push };
  }, [asPath, push]);

  useEffect(() => {
    if (coquille) {
      envoyer({ type: "emplacement", route: asPath });
    }
  }, [coquille, asPath]);

  useEffect(() => {
    if (!coquille || depart.current) {
      return;
    }
    depart.current = true;
    const page = cheminDeLApp(nav?.pageInitiale);
    const espace = espaceDeLaRoute(asPath);
    const duChat = espace ? routeDuChat(nav?.routeDuChat, espace) : null;
    if (duChat) {
      void replace(duChat);
    } else if (page && espace) {
      void replace(routeDeLaPageDeLApp(espace, page));
    }
  }, [coquille, nav?.pageInitiale, nav?.routeDuChat, asPath, replace]);

  useEffect(() => {
    if (!coquille) {
      return;
    }
    const surMessage = (event: MessageEvent) => {
      const chemin = ouvrirDuMessage(
        event,
        window.parent,
        window.location.origin
      );
      const espace = espaceDeLaRoute(routeur.current.asPath);
      if (chemin && espace) {
        void routeur.current.push(routeDeLaPageDeLApp(espace, chemin));
      }
    };
    window.addEventListener("message", surMessage);
    return () => window.removeEventListener("message", surMessage);
  }, [coquille]);

  return null;
}
